<script>
    // @ts-nocheck
    import { TabSet, Button } from '$lib/components/UI'
    import Content from '$lib/components/layout/Content.svelte'
    import MisOfertas from './MisOfertas.svelte'
    import user from '$lib/stores/user.js'
    import MisLicitaciones from './MisLicitaciones.svelte'
    import MisReclamos from './MisReclamos2.svelte'
    import { Router, Route, navigate, useLocation } from 'svelte-navigator'
    const location = useLocation()

    // $: viewOferta = /\/home\/licitaciones\/mis-ofertas/i.test(
    //     $location?.pathname
    // )
    const activeTab = [
        {
            name: 'MisOfertas',
            match: /mis-ofertas/i,
        },
        {
            name: 'MisReclamos',
            match: /mis-reclamos/i,
        },
    ]
    $: current =
        activeTab.find(({ match }) => match.test($location.pathname))?.name ||
        'Licitaciones'
</script>

<Content
    style="display: flex; flex-direction: column;gap: 35px; width: 100%; padding: 25px 68px 68px 68px"
>
    <Router primary={false}>
        <Route path="*">
            <TabSet.Group currentTabId={1}>
                <TabSet.Tab
                    active={current == 'Licitaciones'}
                    label="Licitaciones"
                    on:click={(_) => navigate('/home/licitaciones/')}
                >
                    <MisLicitaciones />
                </TabSet.Tab>
                <!-- <TabSet.Tab
                    active={current == 'MisOfertas'}
                    label="Mis Ofertas"
                    on:click={(_) => navigate('/home/licitaciones/mis-ofertas')}
                >
                    <Route path="mis-ofertas/*">
                        <MisOfertas bind:viewOferta />
                    </Route>
                </TabSet.Tab> -->
                <TabSet.Tab
                    active={current == 'MisReclamos'}
                    label="Mis Reclamos"
                    on:click={(_) =>
                        navigate('/home/licitaciones/mis-reclamos')}
                >
                    <Route path="mis-reclamos/*">
                        <MisReclamos />
                    </Route>
                </TabSet.Tab>
                <svelte:fragment slot="option">
                    <Button
                        label="Ir a Ofertas"
                        size="small"
                        on:click={() => {
                            // window.location.href = window.location.origin+ '/home/ofertas'
                            user.navigate(window.location.origin + '/home/ofertas')
                            // navigate('/home/ofertas', { replace: true })
                        }}
                    />
                </svelte:fragment>
            </TabSet.Group>
        </Route>
    </Router>
</Content>
